/*
  Sharing
*/
$("#share-menu a.in-window").on("click", function (e) {
    e.preventDefault();
    window.open(
        $(this).attr("href"),
        "shareWindow",
        "height=450, width=550, top=" +
            ($(window).height() / 2 - 275) +
            ", left=" +
            ($(window).width() / 2 - 225) +
            ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
    );
});

/*
Comment AJAX
*/
$("body").on("click", "#comment-loader .btn", function (e) {
    e.preventDefault();
    let $loaderEl = $("#comment-loader");
    $(this).attr("disabled", true);
    $.ajax({
        url: $(this).attr("href"),
        success: function (data, textStatus, jqXHR) {
            let $reply = $(data);
            let $newComments = $reply.find(".comment-list");
            let $newLoader = $reply.find("#comment-loader");
            // drop in our new comments
            $(".comment-list").append($newComments.html());
            // WP's comment-reply.js needs to re-init for the new buttons to work
            window.addComment.init();
            // if there's no button in the loader, then we're at the last page.
            if (!$newLoader.find(".btn").length) {
                $loaderEl.hide();
            } else {
                $loaderEl.html($newLoader.html());
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            $loaderEl.html("Sorry, addtional comments could not be loaded.");
        },
    });
});
